module.exports = __webpack_public_path__ + "img/wap_slides_bg_02.2c881563.png";